import { Dropdown, DropdownButton } from "@similarweb/ui-components";
import DropdownItem from "./DropdownItem";
import {
    DropdownContainer,
    DropdownSelector,
    PopupWrapper,
    SegemntsScrollArea,
    SelectedItemsContainer,
    SelectedSegemntsSrollWrapper,
} from "../../styles";
import { DROPDOWN_SEGMENTS_HEIGTH, MAX_SEGMENTS_COUNT, WEBSITE_ID } from "../../constants";
import type { ReactElement } from "react";
import { useCallback } from "react";
import type { ICustomSegmentAccount } from "app/services/segments/segmentsApiService";
import type { SelectedSegmentsId } from "../../types";
import { translate } from "app/filters/i18nFilter";
import { SegmentsChipItem } from "@similarweb/ui-components";

type SegmentsDropdownProps = {
    segments: ICustomSegmentAccount[];
    selectedSegments: ICustomSegmentAccount[];
    setSelectedSegmentsId: (id: ICustomSegmentAccount) => void;
    selectedSegmentsIds: SelectedSegmentsId;
};

const POPUP_ID = "popupWrapper";

const SegmentsDropdown = ({
    selectedSegments,
    segments,
    selectedSegmentsIds,
    setSelectedSegmentsId,
}: SegmentsDropdownProps) => {
    const handleSearch = useCallback(
        (searchText: string, item: ReactElement<{ segment: ICustomSegmentAccount }>): boolean => {
            const segmentName: string = item.props.segment.segmentName;
            const domain: string = item.props.segment.domain;

            return (
                segmentName.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
                domain.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        },
        [],
    );

    const isSegemetsNotSelected = !segments.length;
    const isSegmentLimitReached = selectedSegments?.length === MAX_SEGMENTS_COUNT;
    const isDropdownDisabled = isSegemetsNotSelected || isSegmentLimitReached;

    const placeholderText = isSegmentLimitReached
        ? translate("wizard.segments.group.search.website.segments.limit.reached")
        : translate("wizard.segments.group.search.website.segments");

    return (
        <DropdownContainer>
            {selectedSegments?.length ? (
                <SelectedSegemntsSrollWrapper>
                    <SegemntsScrollArea>
                        <SelectedItemsContainer>
                            {selectedSegments.map((selectedItem, i) => (
                                <SegmentsChipItem
                                    key={i}
                                    text={selectedItem.domain}
                                    secondaryText={selectedItem.segmentName}
                                    image={selectedItem.favicon}
                                    imageAlt={selectedItem.domain}
                                    onRemove={() => setSelectedSegmentsId(selectedItem)}
                                    isWebsite={selectedItem?.type !== WEBSITE_ID}
                                />
                            ))}
                        </SelectedItemsContainer>
                    </SegemntsScrollArea>
                </SelectedSegemntsSrollWrapper>
            ) : null}
            <PopupWrapper id={POPUP_ID} />
            <Dropdown
                selectedIds={selectedSegmentsIds}
                hasSearch
                appendTo={`#${POPUP_ID}`}
                searchFilter={handleSearch}
                disabled={isDropdownDisabled}
                dropdownPopupHeight={DROPDOWN_SEGMENTS_HEIGTH}
                searchPlaceHolder={translate("wizard.segments.group.search.placeholder.website.segments")}
            >
                {[
                    <DropdownSelector
                        isDisabled={isDropdownDisabled}
                        key="uniquekey"
                    >
                        <DropdownButton disabled={isDropdownDisabled}>{placeholderText}</DropdownButton>
                    </DropdownSelector>,
                    ...segments?.map((item) => (
                        <DropdownItem
                            key={item.id}
                            segment={item}
                            setSelectedSegmentsId={setSelectedSegmentsId}
                            isSelectionDisabled={selectedSegments?.length >= MAX_SEGMENTS_COUNT}
                        />
                    )),
                ]}
            </Dropdown>
        </DropdownContainer>
    );
};

export default SegmentsDropdown;
